// 🔧 AddonRequired.js
// ✅ Purpose: Displayed when an event has not purchased a required revenue add-on
// ✅ Features:
// - Consistent add-on gating UI
// - Links managers to Event Settings
// - Reusable across Auction, Tickets, Store, Vendor Payments, Sponsor Payments

import React from "react";
import { Link } from "react-router-dom";

const AddonRequired = ({
  title = "Feature Locked",
  description = "",
  eventslug,
}) => {
  return (
    <div className="container py-5">
      <div
        className="card shadow-sm border-warning mx-auto"
        style={{ maxWidth: "700px" }}
      >
        <div className="card-body text-center p-5">
          <div className="display-4 mb-3">
            🔒
          </div>

          <h2 className="fw-bold mb-3">
            {title}
          </h2>

          <p className="text-muted">
            {description}
          </p>

          {eventslug && (
            <Link
              className="btn btn-success"
              to={`/${eventslug}/event_settings`}
            >
              Manage Add-ons
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddonRequired;